import React from 'react';
import TaskRow from './TaskRow';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { Task } from './api';
import { User } from 'donor/portal/pages/FeedbackDashboard/Feedback/utils';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { RequestState } from 'shared/auth/hooks/useRequestState';
import { Program } from '../Reports/NewReportDialog';
import { NPOUser } from '../ReportsBeta/NewProgram/api';
import { AllocationReportCreationProps } from './Allocation/AllocationReportCreation';
import { ApolloQueryResult } from 'apollo-boost';
import { isLegacyTask, TaskReport, TaskType } from './utils';

export interface SectionTasksProps {
  isDebug: boolean;
  buttonText?: string;
  currentUser: User | undefined;
  sectionName?: string;
  tasks: Task[];
  showFirstSelected: boolean;
  allPrograms: RequestState<{
    allPrograms: Program[];
  }>;
  allNPOUsers: RequestState<{
    allUsers: NPOUser[];
  }>;
  taskReport: TaskReport;
  taskType: TaskType;
  allReports: AllocationReportCreationProps['allReports'];
  reloadTasks: () => unknown;
  reloadPrograms: () =>
    | Promise<
        ApolloQueryResult<{
          allPrograms: Program[];
        }>
      >
    | undefined;
  reloadNPOUser: () => unknown;
}

const StyledDiv = styled.div`
  .tasks-section-name {
    margin-top: ${SPACERS.medium};
  }
`;

const SectionTasks: React.FC<SectionTasksProps> = ({
  isDebug,
  taskType,
  buttonText,
  currentUser,
  sectionName,
  tasks: t,
  allReports,
  allPrograms,
  allNPOUsers,
  taskReport,
  showFirstSelected,
  reloadTasks,
  reloadPrograms,
  reloadNPOUser,
}) => {
  const tasks = t.filter(t => !isLegacyTask(t));
  const totalTasks = tasks.length;
  if (totalTasks === 0) return null;
  return (
    <StyledDiv>
      {sectionName && (
        <TrueImpactText
          variant="heading-label"
          className="tasks-section-name"
          color={showFirstSelected ? 'ctaPrimary' : undefined}
        >
          {sectionName}
        </TrueImpactText>
      )}
      {tasks.map((t, i) => (
        <TaskRow
          isDebug={isDebug}
          taskType={taskType}
          buttonText={buttonText}
          currentUser={currentUser}
          key={t.taskId}
          task={t}
          allReports={allReports}
          taskReport={taskReport}
          allPrograms={allPrograms}
          allNPOUsers={allNPOUsers}
          isSelected={showFirstSelected && i === 0}
          isLastIndex={i === totalTasks - 1}
          reloadTasks={reloadTasks}
          reloadPrograms={reloadPrograms}
          reloadNPOUser={reloadNPOUser}
        />
      ))}
    </StyledDiv>
  );
};

export default SectionTasks;
